import SoapModuleProvider from '../../../context/SoapModuleContext';
import ApiDocModuleProvider from '../../../context/ApiDocModuleContext';
import RestRouter from './rest';
import SoapRouter from './soap';
import RouterBase from '../../../components/navigation/RouterBase';
import { URLAPP } from '../../../config';
import DisplayGroups from '../../../components/navigation/DisplayGroups';

export default function Apidoc() {
    return (
        <RouterBase
            items={[
                {
                    component: <ApiDocModuleProvider>
                        <RestRouter />
                    </ApiDocModuleProvider>,
                    nestedRouter: true,
                    fullPath: URLAPP.apidocRest
                },
                {
                    component: <SoapModuleProvider>
                        <SoapRouter />
                    </SoapModuleProvider>,
                    nestedRouter: true,
                    fullPath: URLAPP.apidocSoap
                },
                {
                    component: <DisplayGroups />,
                    path: "grupo/:grupo",
                    fullPath: URLAPP.apidocGroup
                }
            ]}
        />);
}